import { render, staticRenderFns } from "./ReviewAndUpload.vue?vue&type=template&id=834c735a&scoped=true"
import script from "./ReviewAndUpload.vue?vue&type=script&lang=js"
export * from "./ReviewAndUpload.vue?vue&type=script&lang=js"
import style0 from "./ReviewAndUpload.vue?vue&type=style&index=0&id=834c735a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834c735a",
  null
  
)

export default component.exports